import React from "react";
import {Button, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import {useTranslation} from "react-i18next";

function DialogComponentWithBodyChildren(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'dialogComponentWithBodyChildren' });
    const onClose = props.onClose,
        title = props.title,
        onConfirm = props.onConfirm,
        size = (title.length > 20) ? "lg" : "sm"

    return (
        <Modal
            show={true}
            onHide={onClose}
            size={size}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader closeButton>
                <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody>
                {props.children}
            </ModalBody>
            <ModalFooter>
                <Button variant="primary" active={true} onClick={onClose}>{t('no')}</Button>
                <Button variant="danger" onClick={onConfirm}>{t('yes')}</Button>
            </ModalFooter>
        </Modal>
    )
}

export default DialogComponentWithBodyChildren